import { ContentObjectDetail } from '../content-object-detail';
import { useOrderPostQuery } from '../queries';

type P = {
  orderPostId: string;
};

const WithingsOrderPostDetail = ({ orderPostId }: P) => {
  const { data: contentObject, isLoading } = useOrderPostQuery(orderPostId);

  return <ContentObjectDetail contentObject={contentObject} isLoading={isLoading} />;
};

export default WithingsOrderPostDetail;
